export const trimSlash = (path: string) => {
  if (path.charAt(0) === "/") {
    return path.slice(1);
  }
  return path;
};
